import React, { memo } from 'react';
import classNames from 'classnames';
import ButtonBase from './button-base';

import './button-link.css';

const ButtonLink = (props) => {
  const { className, ...extraProps } = props;

  return (
    <ButtonBase
      className={classNames('button-link', className)}
      {...extraProps}
    />
  );
};

export default memo(ButtonLink);
